<template>
	<div class="card card-shape home-box">
		<div class="card-header">
			<div class="d-flex align-items-center justify-content-between">
				<div class="d-flex align-items-center">
					<h6 class="m-0 fw-bold text-green me-4">Loan Entries</h6>
					<p class="mb-0 akkurate-small me-2 akkurate-orange-text">
						<font-awesome-icon :icon="['fas', 'circle']" />
					</p>
					<span class="small me-3">PP(Principal Paid)</span>
					<p class="mb-0 akkurate-small me-2 akkurate-danger">
						<font-awesome-icon :icon="['fas', 'circle']" />
					</p>
					<span class="small me-3">PB(Principal Balance)</span>
					<p class="mb-0 akkurate-small me-2 akkurate-green">
						<font-awesome-icon :icon="['fas', 'circle']" />
					</p>
					<span class="small me-3">IP(Interest Paid)</span>
					<p class="mb-0 akkurate-small me-2 akkurate-blue-text">
						<font-awesome-icon :icon="['fas', 'circle']" />
					</p>
					<span class="small me-3">IB(Interest Balance)</span>
					<p class="mb-0 akkurate-small me-2 akkurate-purple">
						<font-awesome-icon :icon="['fas', 'circle']" />
					</p>
					<span class="small me-3">ID(Interest Due)</span>
				</div>
				<div class="d-flex">
					<span v-if="rewrtieLoading">
						<b-spinner small class="align-middle"></b-spinner>
					</span>
					<b-link v-else class="fw-semibold ms-2 akkurate-green">
						<font-awesome-icon :icon="['fas', 'arrow-rotate-left']"
							@click="refreshLoanTransactions" /></b-link>
					<filter-view :type="'entries'" :adv_filter="statement_form" :isSearching="isSearching"
						:search="search" @filterLoan="filterLoan"></filter-view>
				</div>
			</div>
		</div>
		<div class="card-body">
			<div class="container">
				<div class="row trans_details">
					<b-table outlined responsive :fields="entries_fields" :items="statement?.account?.transactions">
						<template #table-busy>
							<div class="text-center text-danger my-2">
								<b-spinner class="align-middle"></b-spinner>
								<strong>Loading...</strong>
							</div>
						</template>

						<template #cell(debit)="data">
							<p class="mb-0" v-if="
								data.item.transaction_type ==
								'Loan Disbursed'
							">
								{{ displayNumber(data.item.trans_amount) }}
							</p>
						</template>

						<template #cell(credit)="data">
							<p class="mb-0" v-if="
								data.item.transaction_type ==
								'Loan Repayment'
							">
								{{ displayNumber(data.item.trans_amount) }}
							</p>
						</template>

						<template #cell(description)="data">
							<p class="mb-0">
								{{ data.item.transaction_type }} By
								{{ data.item.transaction_mode }}
							</p>
						</template>

						<template #cell(interest)="data">
							<span>
								{{ displayNumber(data.item.interest) }}
							</span>
						</template>

						<template #cell(action)="data">
							<div class="d-flex">
								<!-- <a v-if="checkPemission()" title="Edit Transaction"
                                    v-b-modal="'edit-transactions' + data.item.id" @click="setEditFormData(data.item)"
                                    class="btn btn-sm akkurate-blue text-white">
                                    <span class="akkurate-small">
                                        <font-awesome-icon :icon="['fas', 'edit']" />
                                    </span>
                                </a> -->
								<b-modal size="lg" :id="'edit-transactions' + data.item.id" @ok="handleOk(data.item)">
									<template #modal-title>
										<h6 class="fw-bold mb-0 akkurate-green">
											Edit Transaction
										</h6>
									</template>
									<edit-loan-transactions :form="edit_form
										"></edit-loan-transactions>
									<template #modal-footer="{ ok }">
										<div class="w-100">
											<!-- Emulate built in modal footer ok and cancel button actions -->
											<b-button @click="
												$bvModal.hide(
													'edit-transactions' +
													data.item.id
												)
												" type="button" class="akkurate-grey-btn border-0 btn-size ms-2 float-right"><span
													class="small"><font-awesome-icon class="me-2" :icon="[
														'fas',
														'close',
													]" />Close
												</span></b-button>
											<b-button @click="ok()" type="submit" :disabled="isSaving"
												class="akkurate-green-btn btn-size float-right border-0"><span
													class="small"><font-awesome-icon class="me-2" :icon="[
														'fas',
														'save',
													]" />Update</span></b-button>
										</div>
									</template>
								</b-modal>
								<a title="Receipts" class="btn btn-sm akkurate-green-btn text-white"
									@click="printReceipt(data)">
									<span class="akkurate-small">
										<font-awesome-icon :icon="['fas', 'book']" />
									</span>
								</a>
								<div title="Cheque" class="dropdown no-arrow"
									v-if="data.item.transaction_mode == 'Cheque'">
									<a title="Cheque" class="btn btn-sm akkurate-gray-btn text-white dropdown-toggle"
										id="dropdownMenu" data-bs-toggle="dropdown" aria-haspopup="true"
										aria-expanded="false">
										<span class="akkurate-small">
											<font-awesome-icon :icon="['fas', 'money-bill']" />
										</span>
									</a>
									<div class="dropdown-menu shadow animated--fade-in" aria-labelledby="dropdownMenu">
										<div class="dropdown-header">
											Statments
										</div>
										<button class="dropdown-item" @click="chequePrintout(data)">
											Cheque Printout
										</button>
										<button class="dropdown-item" @click="chequeTemplate(data)">
											Cheque Template
										</button>
									</div>
								</div>
								<a v-if="reversePermission()" title="Reverse"
									class="btn btn-sm akkurate-danger-btn text-white" @click="loanReverse(data.item)">
									<span class="akkurate-small"><font-awesome-icon
											:icon="['fas', 'exchange-alt']" /></span>
								</a>
								<a v-if="showTransferRepaymentToSavings(data.item)" :title="trtsCopy.label"
									class="btn btn-sm akkurate-blue text-white"
									@click="transferRepaymentToSavings(data.item)">
									<span class="akkurate-small"><font-awesome-icon
											:icon="['fas', 'piggy-bank']" /></span>
								</a>
							</div>
						</template>

						<template #custom-foot>
							<tr>
								<td class="fw-bold">Total</td>
								<td class="fw-bold"></td>
								<td class="fw-bold">
									{{ displayNumber(total_debit) }}
								</td>
								<td class="fw-bold">
									{{ displayNumber(total_credit) }}
								</td>
								<td class="fw-bold"></td>
								<td class="fw-bold"></td>
								<td class="fw-bold"></td>
								<td class="fw-bold">
									{{ displayNumber(total_principal) }}
								</td>
								<td class="fw-bold"></td>
								<td class="fw-bold"></td>
								<td class="fw-bold">
									{{ displayNumber(total_interest) }}
								</td>
								<td class="fw-bold"></td>
							</tr>
						</template>
					</b-table>
				</div>
			</div>
		</div>
		<cheque-printout ref="showChequePrintout" :report_data="report_data"></cheque-printout>
		<cheque-template ref="showChequeTemplate" :report_data="report_data"></cheque-template>
		<direct-momo-debit-repayment ref="showDirectDebitRepayment"
			:reportData="report_data"></direct-momo-debit-repayment>
		<momo-merchant-repayment ref="showMerchantRepayment" :reportData="report_data"></momo-merchant-repayment>
		<cheque-repayment ref="showChequeRepayment" :reportData="report_data"></cheque-repayment>
		<setoff-repayment ref="showSetOffRepayment" :report_data="report_data"></setoff-repayment>

		<cash-repayment ref="showCashRepayment" :reportData="report_data"></cash-repayment>
		<cash-disbursement ref="showCashDisbursement" :report_data="report_data"></cash-disbursement>
		<cheque-disbursement ref="showChequeDisbursement" :report_data="report_data"></cheque-disbursement>
	</div>
</template>

<script>
import ChequePrintout from "../../reports/printout/ChequePrintout.vue";
import ChequeTemplate from "../../reports/printout/ChequeTemplate";
import ChequeRepayment from "../../reports/cheque/ChequeRepayment.vue";
import SetoffRepayment from "../../reports/set-off/SetoffRepayment.vue";
import CashRepayment from "../../reports/cash/CashRepayment.vue";
import DirectMomoDebitRepayment from "../../reports/direct-debit/DirectMomoDebitRepayment.vue";
import MomoMerchantRepayment from "../../reports/momo/MomoMerchantRepayment.vue";
import CashDisbursement from "../../reports/cash/CashDisbursement.vue";
import ChequeDisbursement from "../../reports/cheque/ChequeDisbursement.vue";
import FilterView from "../FilterView.vue";
import ApiService from "@/core/services/api.service";
import EditLoanTransactions from "../../forms/EditLoanTransactions.vue";
import { hasPermission } from "@/helper";
import {
	canTransferRepaymentToSavings,
	promptTransferLoanRepaymentToSavings,
} from "@/utils/loanRepaymentTransfer";
import { TRANSFER_REPAYMENT_TO_SAVINGS } from "@/constants/transferRepaymentToSavingsCopy";
export default {
	props: ["loan", "institution", "statement_form", "statement"],
	components: {
		ChequePrintout,
		ChequeTemplate,
		ChequeRepayment,
		SetoffRepayment,
		CashRepayment,
		DirectMomoDebitRepayment,
		MomoMerchantRepayment,
		CashDisbursement,
		ChequeDisbursement,
		FilterView,
		EditLoanTransactions,
	},
	// mounted() {
	// 	// console.log(this.loan_number)
	// 	this.filterLoan();
	// },
	data() {
		return {
			trtsCopy: TRANSFER_REPAYMENT_TO_SAVINGS,
			isCashRepayment: false,
			rewrtieLoading: false,
			edit_form: {
				trans_date: "",
				principal: "",
				interest: "",
				principal_balance: "",
				interest_balance: "",
				principal_paid: "",
				interest_paid: "",
			},
			isSaving: false,
			isSearching: false,
			search: "Search",
			report_data: [],
			entries_fields: [
				{
					key: "trans_date",
					label: "Date",
				},

				{
					key: "description",
					label: "Description",
				},
				{
					key: "debit",
					label: "Debit",
				},
				{
					key: "credit",
					label: "Credit",
				},

				{
					key: "previous_balance",
					label: "Previous Balance",
				},

				{
					key: "loan_interest_due",
					label: "ID",
				},
				{
					key: "loan_principal_due",
					label: "PD",
				},

				{
					key: "principal",
					label: "Principal",
				},
				{
					key: "principal_paid",
					label: "PP",
				},
				{
					key: "principal_balance",
					label: "PB",
				},
				{
					key: "interest",
					label: "Interest",
				},
				{
					key: "interest_paid",
					label: "IP",
				},
				{
					key: "interest_balance",
					label: "IB",
				},
				{
					key: "action",
					label: "Action",
				},
			],
			entries_items: [],
		};
	},
	computed: {
		getFullName() {
			const first_name =
				this.statement.account.customer?.first_name ?? "";
			const middle_name = this.loan.account.customer?.middle_name ?? "";
			const last_name = this.loan.account.customer?.last_name ?? "";
			return first_name + " " + middle_name + " " + last_name;
		},
		getBranch() {
			const branch = this.loan?.account?.customer?.branch?.name ?? "";
			return branch;
		},
		total_credit() {
			return this.entries_items
				.filter(
					(trans) => trans.transaction_type == "Loan Repayment"
				)
				.reduce((total, trans) => total + trans.trans_amount, 0);
		},
		total_debit() {
			return this.entries_items
				.filter(
					(trans) => trans.transaction_type != "Loan Repayment"
				)
				.reduce((total, trans) => total + trans.trans_amount, 0);
		},
		total_principal() {
			return (
				this.entries_items
					// .filter(trans => trans.transaction_type != 'Loan Repayment')
					.reduce((total, trans) => total + trans.principal, 0)
			);
		},
		total_interest() {
			return this.entries_items.reduce(
				(total, trans) => total + trans.interest,
				0
			);
		},
	},
	methods: {
		checkPemission() {
			if (hasPermission("loan_management_transaction_edit")) {
				return true;
			} else {
				return false;
			}
		},
		reversePermission() {
			if (hasPermission("loan_management_transaction_reverse")) {
				return true;
			} else {
				return false;
			}
		},
		transferRepaymentToSavingsPermission() {
			return hasPermission("loan_repayment_transfer_to_savings");
		},
		showTransferRepaymentToSavings(trans) {
			return (
				this.transferRepaymentToSavingsPermission() &&
				canTransferRepaymentToSavings(trans)
			);
		},
		filterLoan() {
			this.$emit('refreshStatement')
		},
		// async filterLoan() {
		// 	this.search = "processing...";
		// 	this.isSearching = true;
		// 	await ApiService.query("/loans/loanStatements", {
		// 		params: {
		// 			loan_number: this.loan_number,
		// 			start_date: this.adv_filter?.start_date,
		// 			end_date: this.adv_filter?.end_date,
		// 		},
		// 	})
		// 		.then((response) => {
		// 			// console.log(response.data.data);
		// 			this.details = response.data.data;
		// 			this.isLoading = false;
		// 			this.statement_items =
		// 				response.data.data.account.transactions.map(
		// 					(index) => {
		// 						return {
		// 							id: index.id,
		// 							trans_date: index.trans_date,
		// 							transaction_type: index.transaction_type,
		// 							transaction_mode: index.transaction_mode,
		// 							trans_amount: index.trans_amount,
		// 							debit: Math.round(index.debit * 100) / 100,
		// 							credit: Math.round(index.credit * 100) / 100,
		// 							previous_balance: Math.round(index.previous_balance * 100) / 100,
		// 							principal: Math.round(index.principal * 100) / 100,
		// 							principal_paid: Math.round( index.principal_paid * 100 ) / 100,
		// 							principal_balance: Math.round(index.principal_balance * 100) / 100,
		// 							interest_paid: Math.round(index.interest_paid * 100) / 100,
		// 							interest_balance:Math.round(index.interest_balance * 100) / 100,
		// 							interest: index.interest,
		// 							denominations: index.denominations,
		// 							loan_interest_due:index.loan_interest_due,
		// 							loan_principal_due:index.loan_principal_due,
		// 							cheque_number: index.cheque_number,
		// 							code: index.code,
		// 						};
		// 					}
		// 				);
		// 			this.entries_items = this.statement_items;
		// 			// this.handleImageLoad();
		// 			this.search = "Search";
		// 			this.isSearching = false;
		// 		})
		// 		.catch((error) => {
		// 			this.search = "Search";
		// 			this.isSearching = false;
		// 			console.log(error);
		// 			if (error.response.status == 404) {
		// 				swal.fire({
		// 					icon: "error",
		// 					title: error.response.statusText,
		// 					text: "Something went wrong!",
		// 					showCancelButton: false, // Show the "Cancel" button
		// 					confirmButtonText: "OK", // Customize the text for the "OK" button
		// 					buttonsStyling: false, // Disable SweetAlert2 styling for buttons
		// 					customClass: {
		// 						confirmButton:
		// 							"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
		// 					},
		// 					// footer: '<a href="#">Why do I have this issue?</a>'
		// 				});
		// 			}
		// 		});
		// },
		getOneMonthBeforeDate() {
			// Get today's date
			let currentDate = new Date();

			// Remove one month to the current date
			currentDate.setMonth(currentDate.getMonth() - 1);

			// Format the date as 'YYYY-MM-DD'
			return currentDate.toISOString().substr(0, 10);
		},
		chequePrintout(data) {
			console.log(data)
			this.report_data = {
				'trans_date': data.item?.trans_date,
				'teller': this.getTeller,
				'account_number': this.loan?.account_number,
				'loan_number': this.loan.loan_number,
				'fullname': this.getFullNameAndID,
				'transcation_mode': data.item.transaction_mode,
				'transaction_type': data.item.transaction_type,
				'amount': data.item?.trans_amount,
				'denomination': data.item?.denominations,
				'branch_name': this.loan.account?.customer?.branch?.name,
				'receipt_no': data.item.id,
				institution: this.institution,
			};
			this.$refs.showChequePrintout.showModal();
		},
		chequeTemplate(data) {
			this.report_data = {
				'trans_date': data.item?.trans_date,
				'teller': this.getTeller,
				'account_number': this.loan?.account_number,
				'loan_number': this.loan.loan_number,
				'fullname': this.getFullNameAndID,
				'transcation_mode': data.item.transaction_mode,
				'transaction_type': data.item.transaction_type,
				'amount': data.item?.trans_amount,
				'denomination': data.item?.denominations,
				'branch_name': this.loan.account?.customer?.branch?.name,
				'receipt_no': data.item.id,
				institution: this.institution,
			};
			this.$refs.showChequeTemplate.showModal();
		},
		printReceipt(data) {
			// console.log(this.loan);
			this.report_data = {
				trans_date: data.item?.trans_date,
				// teller: this.getTeller,
				account_number: this.loan?.account?.account_number,
				loan_number: this.loan?.loan_number,
				fullname: this.getFullName,
				transcation_mode: data.item.transaction_mode,
				transaction_mode: data.item.transaction_mode,
				transaction_type: data.item.transaction_type,
				amount: data.item?.trans_amount,
				denomination: data.item?.denominations,
				branch_name: this.loan?.account?.customer?.branch?.name,
				receipt_no: data.item.id,
				institution: this.institution,
				description: data.item.transaction_type + " By " + data.item.transaction_mode,
				cheque_number: data?.item.cheque_number,
				code: data.item?.code,
				transaction_id: data.item?.code,
				merchant_number: data.item?.merchant_number,
				mobile: data.item?.mobile,
			};
			if (data.item.transaction_type == "Loan Repayment") {
				switch (data.item.transaction_mode) {
					case "Cash":
						this.$refs.showCashRepayment.showModal();
						break;
					case "Cheque":
						this.$refs.showChequeRepayment.showModal();
						break;
					case "Momo Merchant":
					case "MOMO Merchant":
						this.$refs.showMerchantRepayment.showModal();
						break;
					case "Direct Momo Debit":
					case "Direct MOMO Debit":
						this.$refs.showDirectDebitRepayment.showModal();
						break;
					case "Set-Off":
					case "Set-off":
						this.$refs.showSetOffRepayment.showModal();
						break;
				}
				// this.$refs.showCashRepayment.showModal();
			} else if (data.item.transaction_type == "Loan Disbursed") {
				switch (data.item.transaction_mode) {
					case "Cash":
						this.$refs.showCashDisbursement.showModal();
						break;
					case "Cheque":
						this.$refs.showChequeDisbursement.showModal();
						break;
					case "Momo Merchant":
						this.$refs.showMomoDisbursement.showModal();
						break;
					case "Direct Momo Debit":
						this.$refs.showDirectDebitDisbursement.showModal();
						break;
					case "Set-Off":
						this.$refs.showSetOffDisbursement.showModal();
						break;
				}
			}
			// switch (data.item.transaction_mode) {
			// 	case "Cash":
			// 		if (data.item.transaction_type == "Loan Repayment") {
			// 			this.isCashRepayment = true;
			// 			this.$refs.showCashRepayment.showModal();
			// 		} else if (
			// 			data.item.transaction_type == "Loan Disbursed"
			// 		) {
			// 			this.$refs.showCashDisbursement.showModal();
			// 		}
			// 		break;
			// 	case "Cheque":
			// 		if (data.item.transaction_type == "Loan Repayment") {
			// 			this.$refs.showChequeRepayment.showModal();
			// 		} else if (
			// 			data.item.transaction_type == "Loan Disbursed"
			// 		) {
			// 			this.$refs.showChequeDisbursement.showModal();
			// 		}
			// 		break;
			// 	case "MOMO Merchant":
			// 		console.log("MOMO Merchant");
			// 		if (data.item.transaction_type == "Loan Repayment") {
			// 			this.$refs.showMerchantRepayment.showModal();
			// 		} else if (
			// 			data.item.transaction_type == "Loan Disbursed"
			// 		) {
			// 			this.$refs.showMerchantDisbursement.showModal();
			// 		}
			// 		break;
			// 	case "Direct Momo Debit":
			// 		if (data.item.transaction_type == "Loan Repayment") {
			// 			this.$refs.showDirectDebitRepayment.showModal();
			// 		} else if (
			// 			data.item.transaction_type == "Loan Disbursed"
			// 		) {
			// 			this.$refs.showDirectDebitDisbursement.showModal();
			// 		}
			// 		break;
			// 	case "Set-Off":
			// 		if (data.item.transaction_type == "Loan Repayment") {
			// 			// console.log(data.item.transaction_type)
			// 			console.log(this.$refs.showSetOffRepayment);
			// 			this.$refs.showSetOffRepayment.showModal();
			// 		} else if (
			// 			data.item.transaction_type == "Loan Disbursed"
			// 		) {
			// 			this.$refs.showSetOffDisbursement.showModal();
			// 		}
			// 		break;
			// }

		},
		handleOk(data) {
			this.updateTransaction(data);
		},

		async updateTransaction(data) {
			await ApiService.put(
				`/loans/transactions/${data.id}/update`,
				this.edit_form
			)
				.then((response) => {
					this.isLoadingSaving = false;
					this.$Progress.finish();
					toast.fire({
						icon: "success",
						title: response.data.message,
					});
					this.isSaving = false;
					this.filterLoan();
				})
				.catch((error) => {
					this.isSaving = false;
					this.$Progress.fail();
					if (error.response.data.errors) {
						this.form.errors = error.response.data.errors;
					}
				});
		},

		async refreshLoanTransactions() {
			this.rewrtieLoading = true;
			console.log(this.loan);
			await ApiService.post(
				`/loans/transactions/${this.loan?.account_id}/rewrite/balance`
			)
				.then((response) => {
					this.isLoadingSaving = false;
					this.$Progress.finish();
					toast.fire({
						icon: "success",
						title: response.data.message,
					});
					this.isSaving = false;
					this.filterLoan();
					this.rewrtieLoading = false;
				})
				.catch((error) => {
					this.isSaving = false;
					this.$Progress.fail();
					if (error.response.data.errors) {
						this.form.errors = error.response.data.errors;
					}
					this.rewrtieLoading = false;
				});
		},
		setEditFormData(item) {
			this.edit_form = {
				trans_date: item.trans_date,
				principal: item.principal,
				interest: item.interest,
				principal_balance: item.principal_balance,
				interest_balance: item.interest_balance,
				principal_paid: item.principal_paid,
				interest_paid: item.interest_paid,
			};
		},
		transferRepaymentToSavings(trans) {
			const customerId =
				this.loan?.account?.customer?.id ??
				this.statement?.account?.customer?.id;
			promptTransferLoanRepaymentToSavings(this, {
				trans,
				customerId,
				onSuccess: () => this.filterLoan(),
			});
		},
		loanReverse(trans) {
			swal.fire({
				title: "Reverse Transaction",
				text: `Are you sure you want to reverse repayment ${trans.code}?`,
				icon: "warning",
				showCancelButton: true,
				confirmButtonText: "Yes",
				cancelButtonText: "No",
				allowOutsideClick: true,
				customClass: {
					confirmButton:
						"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
					cancelButton:
						"btn btn-size akkurate-danger-btn modal-btn-width text-white", // Custom class for the custom button
				},
			}).then((result) => {
				if (result.value) {
					this.$Progress.start();
					ApiService.post("loans/transactions/reverse", {
						transaction_id: trans.id,
					})
						.then((respp) => {
							this.$Progress.finish();
							toast.fire({
								icon: "success",
								title: respp.data.message,
							});

							this.filterLoan();
						})
						.catch((error) => {
							this.$Progress.fail();
						});
				}
			});
		},
	},
};
</script>
